module.exports = __webpack_public_path__ + "media/images/en/replace-21ef2e399afc780f15e1b62903bb490c.png";